module.exports = __webpack_public_path__ + "static/media/logo.d873dc54.svg";